import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../layouts/Footer";
import Navbar from "../../layouts/Navbar";
import Carousel from "react-bootstrap/Carousel";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import "../../styles/DetailScreen.css";
import Play from "../../assets/images/Play.png";
import Pause from "../../assets/images/Pause.png";
import api from "../../api/config";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import ConnectModal from "../../components/user/ConnectModal";
import ImageModal from "../../components/common/custom-modals/ImageModal";
import { DEFAULT_PROFILE_IMG } from "../../constants/common";

function PropertyDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [images, setImges] = useState([]);
  const [map, setMap] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [propertyDetail, setPropertyDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [propertyName , setPropertyName] = useState(propertyDetail?.name)
  const [propertyAddress, setPropertyAddress] = useState(propertyDetail?.address1?.replace(/\bUnited States\b/gi, '')      
  ?.replace(/\bNew York\b,?\s*/gi, '')      )

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const videoRef = useRef(null);
  const { id } = useParams();

  const togglePlayPause = () => {
    setIsPlaying((prevState) => !prevState);
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
  };

  const propertyDetails = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/space-feed-details/${id}`);
      if (response.status === 200) {
        setPropertyDetail(response?.data?.response);
        setLat(response?.data?.response?.latitude);
        setLng(response?.data?.response?.longitude);
      }
    } catch (error) {
      toast.error("Something went wrong");
      //console.logerror, "error");
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    propertyDetails();
  }, []);

  const [isMapViewClicked, setIsMapViewClicked] = useState(true);
  const [isMapViewClickedExpand, setIsMapViewClickedExpand] = useState(false);

  const ExpandMapView = (event) => {
    event.stopPropagation(); // This stops the event from propagating further
    setIsMapViewClickedExpand(!isMapViewClickedExpand); // Toggle the state
  };

  useEffect(() => {
    if (!!lat && !!lng) {
      const loadMapScript = () => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o&libraries=places`;
        script.async = true;
        script.onload = initializeMap;
        document.body.appendChild(script);
      };

      loadMapScript();

      return () => {
        // Cleanup function to remove the script
        const scripts = document.getElementsByTagName("script");
        for (let i = 0; i < scripts.length; i++) {
          if (scripts[i].src.includes("maps.googleapis.com")) {
            scripts[i].remove();
          }
        }
      };
    }
  }, [lat, lng]);

  const initializeMap = () => {
    const newMap = new window.google.maps.Map(document.getElementById("map"), {
      center: {
        lat: Number(propertyDetail?.latitude),
        lng: Number(propertyDetail?.longitude),
      }, // Set your initial center here
      zoom: 15,
    });

    // Create a marker and set its position
    const marker = new window.google.maps.Marker({
      position: {
        lat: Number(propertyDetail?.latitude),
        lng: Number(propertyDetail?.longitude),
      },
      map: newMap,
      title: "Property Location",
    });

    setMap(newMap);
  };

  const formatAddress = (address) => {
    if (!address) return "";   // null/undefined 안전 처리
  
    return address
      .replace(/,\s*USA/g, '')
      .replace(/\bUnited States\b/gi, '')
      .replace(/\bNew York\b,?\s*/gi, '')
      .replace(/\b[A-Z]{2,}\b/g, '')
      .trim();
  };
//  const formatAddress = (address) => {
//      return address
//    .replace(/,\s*USA/g, '')                 // Remove ", USA"
//    .replace(/\bUnited States\b/gi, '')      // Remove "United States" (case-insensitive)
//    .replace(/\bNew York\b,?\s*/gi, '')      // Remove "New York" and any following comma and space (case-insensitive)
//    .replace(/\b[A-Z]{2,}\b/g, '')           // Remove state abbreviations (two or more uppercase letters)
//    .trim();
//  };

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div
        className="container-fluid border-bottom"
        style={{ paddingTop: "7.5%" }}
      >
        {loading ? (
          <>
            <Skeleton height={400} width={1342} />
          </>
        ) : (
          <>
            <div className="d-flex justify-content-center custom-property">
              <div
                className="carousel-container custom-carousel"
                style={{
                  width: isMapViewClickedExpand
                    ? "0%"
                    : isMapViewClicked
                    ? "50%"
                    : "100%",
                }}
              >
                <Carousel style={{ minHeight: "400px" }}>
                  {propertyDetail?.spaceFeedMedia?.map((item, index) => (
                    <Carousel.Item
                      interval={5000}
                      style={{ minHeight: "400px" }}
                    >
                      {item?.url?.includes("mp4") ? (
                        <video
                          ref={videoRef}
                          type="video/mp4"
                          className="d-block w-100"
                          src={item?.url}
                          alt="Card cap"
                          height={400}
                          onClick={(e) => {
                            e.preventDefault();
                            setIsModalOpen(true);
                            setSelectedImage(index)
                            setImges(propertyDetail?.spaceFeedMedia);
                          }}
                        />
                      ) : (
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            setIsModalOpen(true);
                            setSelectedImage(index)
                            setImges(propertyDetail?.spaceFeedMedia);
                          }}
                        >
                          <img
                            className="d-block w-100"
                            src={item?.url}
                            alt="Property"
                            height={400}
                          />
                        </div>
                      )}
                      <div className="custom-controls m-4">
                        <span className="p-2">{`${index + 1} / ${
                          propertyDetail?.spaceFeedMedia?.length
                        }`}</span>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              <div
                className="map-container custom-map-container"
                style={{
                  width: isMapViewClickedExpand
                    ? "100%"
                    : isMapViewClicked
                    ? "50%"
                    : "0%",
                  transition: "width 0.5s ease-in-out",
                  position: "relative",
                }}
              >
                <div id="map" style={{ width: "100%", height: "400px" }}></div>
                {
                  isMapViewClicked && !isMapViewClickedExpand && (
                    <button
                      className="expand-map-btn"
                      onClick={(event) => ExpandMapView(event)}
                    >
                      Expand Map View
                    </button>
                  )
                }

                {isMapViewClickedExpand && (
                  <button
                    className="exit-map-btn"
                    onClick={(event) => ExpandMapView(event)}
                  >
                    Exit Map View
                  </button>
                )}
              </div>
            </div>

            <div className="container-fluid my-3">
              <span className="fw-bold text-black">{propertyDetail?.name}</span>
              <br />
              {/* <span>
                {[
                  formatAddress(propertyDetail?.address1),
                  formatAddress(propertyDetail?.address2),
                  propertyDetail?.city &&
                  !propertyDetail?.address1?.includes(propertyDetail.city) &&
                  !propertyDetail?.address2?.includes(propertyDetail.city)
                    ? propertyDetail.city
                    : null,
                  propertyDetail?.state &&
                  !propertyDetail?.address1?.includes(propertyDetail.state) &&
                  !propertyDetail?.address2?.includes(propertyDetail.state)
                    ? propertyDetail.state
                    : null,
                  propertyDetail?.pin &&
                  !propertyDetail?.address1?.includes(propertyDetail.pin) &&
                  !propertyDetail?.address2?.includes(propertyDetail.pin)
                    ? propertyDetail.pin
                    : null,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </span> */}
              <span> { propertyDetail?.address1
  ?.replace(/USA/i, "")
  ?.replace(/\bUnited States\b/gi, '')      // Remove "United States" (case-insensitive)
  ?.replace(/\bNew York\b,?\s*/gi, '')      // Remove "New York" and any following comma and space (case-insensitive)
  ?.replace(/,\s*$/, "")}
</span>
              <br />
            </div>
          </>
        )}
      </div>

      <div className="container-fluid border-bottom">
        <div className="container-fluid my-3">
          <div className="d-flex justify-content-start custom-contents">
            {loading ? (
              <>
                <Skeleton width={400} height={350} />
              </>
            ) : (
              <>
                <div className="col-6" style={{ width: "max-content" }}>
                  <h6 className="fw-bold "> Details</h6>
                  <div className="detail-block  w-100 text-start ">
                    <div className="detail-item mb-2 d-flex justify-content-start align-items-center ">
                      <span className="label fw-normal text-black col-8 ">
                        Property type :{" "}
                      </span>
                      <span className="text col-4">
                        {propertyDetail?.categoryName}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Price/SQFT :
                      </span>
                      <span className="text">
                        {" "}
                        {propertyDetail?.spaceFeedDetails?.price}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Total SQFT :
                      </span>
                      <span className="text col-4">
                        {" "}
                        {propertyDetail?.spaceFeedDetails?.totalSpace}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Remaining Lease Term :
                      </span>
                      <span className="text col-4">
                        {" "}
                        {
                          propertyDetail?.spaceFeedDetails?.remainingLeaseTerm
                        }{" "}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Business type :
                      </span>
                      <span className="text col-4">
                        {propertyDetail?.spaceFeedDetails?.businessType}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">Layout :</span>
                      <span className="text col-4">
                        {propertyDetail?.spaceFeedDetails?.layout}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="custom-details-secondblock" style={{ width: "max-content", marginLeft: "15rem" }}>
                  <h6 className="fw-bold"> &nbsp;</h6>

                  <div className="detail-block  w-100 text-start custom-details">
                    <div className="detail-item mb-2 d-flex justify-content-start align-items-center">
                      <span className="label fw-normal col-8">Subtype : </span>
                      <span className="text col-4">
                        {" "}
                        {propertyDetail?.subCategoryName}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Total Rent Fee + Other Costs :
                      </span>
                      <span className="text col-4">
                        ${propertyDetail?.spaceFeedDetails?.rent}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Available SQFT :
                      </span>
                      <span className="text col-4">
                        {propertyDetail?.spaceFeedDetails?.availableSpace}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Minimum Sub Lease Term :
                      </span>
                      <span className="text col-4">
                        {propertyDetail?.spaceFeedDetails?.minSubLeaseTerm}{" "}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">
                        Sub Lease Business Type :
                      </span>
                      <span className="text col-4">
                        {" "}
                        {propertyDetail?.spaceFeedDetails?.subBusinessType}
                      </span>
                    </div>
                    <div className="detail-item mb-2 d-flex align-items-center">
                      <span className="label fw-normal col-8">Parking :</span>
                      <span className="text col-4">
                        {propertyDetail?.spaceFeedDetails?.parking}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="container-fluid border-bottom">
        <div className="container-fluid my-3">
          <div className="d-flex justify-contetn-start">
            <div style={{ width: "max-content" }}>
              <h6 className="fw-bold"> Description</h6>
              {loading ? (
                <Skeleton width={1342} count={4} />
              ) : (
                <p className="text-black">
                  {propertyDetail?.spaceFeedDetails?.description}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid border-bottom">
        <div className="container-fluid my-3">
          <div className="d-flex justify-contetn-start">
            <div style={{ width: "max-content" }}>
              <h6 className="fw-bold"> Provider Information</h6>

              <div className="assign-doctor-card">
                <div className="d-flex custom-doctorcard">
                  <div className="image-part  justify-content-left">
                    {loading ? (
                      <Skeleton circle height={80} width={80} />
                    ) : (
                      <img
                        src={
                          !!propertyDetail?.providerDetails?.profileImage
                            ? propertyDetail?.providerDetails?.profileImage
                            : DEFAULT_PROFILE_IMG
                        }
                        height={120}
                        width={120}
                        style={{ borderRadius: "50%" }}
                        alt="Patient"
                      />
                    )}

                    <br />
                    <span className="fw-bold mt-3  d-flex justify-content-left">
                      {loading ? (
                        <Skeleton />
                      ) : (
                        `${propertyDetail?.providerDetails?.firstName} ${propertyDetail?.providerDetails?.lastName}`
                      )}
                    </span>
                  </div>
                  {loading ? (
                    <Skeleton
                      style={{ marginLeft: "20px" }}
                      height={100}
                      width={1000}
                    />
                  ) : (
                    <>
                      <div
                        className="text-part d-flex flex-column justify-content-center custom-address"
                        style={{ marginLeft: "2rem" }}
                      >
                        <span className="name d-flex justify-content-start align-items-center">
                          License {"\u00A0"} {"\u00A0"}{" "}
                          {propertyDetail?.providerDetails?.licenseNo
                            ? propertyDetail.providerDetails.licenseNo
                            : "Not Available"}
                        </span>

                        <span className="name d-flex justify-content-center align-items-center">
                          Address {"\u00A0"} {"\u00A0"}{" "}
                          {formatAddress(propertyDetail?.providerDetails?.address)}
                        </span>
                      </div>
                      <div
                        className="text-part d-flex flex-column justify-content-center custom-call "
                        style={{ marginLeft: "2rem" }}
                      >
                        <button
                          type="button"
                          className=" border-0 d-flex justify-content-between px-2 py-2 align-items-center pe-none"
                          style={{
                            whiteSpace: "nowrap",
                            display: "inline-flex",
                            backgroundColor: "#F5C000",
                            marginTop: "1rem",
                            fontWeight: "bold",
                            borderRadius: "10px",
                          }}
                        >
                          Call +{propertyDetail?.providerDetails?.mobile} &nbsp;{" "}
                          <FontAwesomeIcon icon={faPhone} />
                        </button>

                        <button
                          type="button"
                          onClick={handleShow}
                          className=" border-0 d-flex justify-content-between px-2 py-2 align-items-center"
                          style={{
                            whiteSpace: "nowrap",
                            display: "inline-flex",
                            backgroundColor: "#F5C000",
                            marginTop: "1rem",
                            fontWeight: "bold",
                            borderRadius: "10px",
                          }}
                        >
                          Contact with{" "}
                          {propertyDetail?.providerDetails?.firstName}{" "}
                          <FontAwesomeIcon
                            style={{
                              marginLeft: "1rem",
                            }}
                            icon={faEnvelope}
                          />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageModal
        show={isModalOpen}
        images={images}
        onClose={() => setIsModalOpen(false)}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
      />
      <Footer />
      <ConnectModal handleClose={handleClose} show={show} propertyName={propertyDetail?.name} propertyAddress={propertyDetail?.address1
  ?.replace(/USA/i, "")
  ?.replace(/\bUnited States\b/gi, '')      // Remove "United States" (case-insensitive)
  ?.replace(/\bNew York\b,?\s*/gi, '')      // Remove "New York" and any following comma and space (case-insensitive)
  ?.replace(/,\s*$/, "")}
  />
    </>
  );
}
export default PropertyDetail;
